/* Pinzelli (07/10/2026) : UN événement Klaviyo « Pinzelli · Panier mis à jour » à chaque ajout au panier réussi,
   sur tout le site et quelle que soit la source (lots pz-offer, packs pinzelli-bundle, Signature seule, Magnéclip,
   ajout rapide collection, upsells du panier Kaching…), avec le contenu du PANIER COMPLET lu dans /cart.js.
   - Chargé dans layout/theme.liquid AVANT {{ content_for_header }} : les applis (Kaching, Shopify Web Pixels…)
     enveloppent fetch/XHR après nous, donc tous leurs appels /cart/add passent par ici.
   - Les ajouts rapprochés (< 1,5 s : ex. ligne témoin d'un lot + cadeaux ajoutés par une appli) = 1 seul événement.
   - Le reste d'un lot ajouté « en discret » (iframe, voir pz-offer-v5.js / pz-legacy-lot.js) n'est pas vu ici, mais la
     ligne témoin l'est, et /cart.js est lu après : le panier envoyé est complet.
   - Lot : nom lu dans la propriété « Lot » des lignes ajoutées ; pz-offer/pz-legacy-lot peuvent préciser le nombre de
     pinces via window.pzLotHint = { pack, label, pinces }.
   Klaviyo n'envoie l'événement que si la visiteuse est identifiée. */
(function () {
  if (window.__pzCartEvents) return;
  window.__pzCartEvents = true;
  var NAME = 'Pinzelli · Panier mis à jour';
  var ADD = /\/cart\/add(\.js|\.json)?(\?|#|$)/;
  var nf = window.fetch, timer = null, added = [];
  function isAdd(u) { try { return ADD.test(String(u || '')); } catch (e) { return false; } }
  function readBody(b) {
    var out = [];
    try {
      if (typeof b === 'string') {
        var j = JSON.parse(b), list = j.items || (j.id ? [j] : []);
        list.forEach(function (it) { out.push({ id: +it.id, props: it.properties || {} }); });
      } else if (b && typeof b.get === 'function') {
        var p = {}; if (b.get('properties[Lot]')) p.Lot = b.get('properties[Lot]');
        if (b.get('properties[_pz_pack]')) p._pz_pack = b.get('properties[_pz_pack]');
        out.push({ id: +b.get('id'), props: p });
      }
    } catch (e) {}
    return out;
  }
  function schedule(body) {
    added = added.concat(readBody(body));
    clearTimeout(timer);
    timer = setTimeout(send, 1500);
  }
  function send() {
    var just = added; added = [];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var abs = function (u) { u = u || ''; return u.indexOf('//') === 0 ? 'https:' + u : (u.charAt(0) === '/' ? location.origin + u : u); };
    nf.call(window, root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var paid = [], gifts = [];
      (cart.items || []).forEach(function (l) {
        var pr = l.properties || {};
        if (l.original_price > 0) paid.push({ ProductName: l.product_title, Variant: l.variant_title || '', Quantity: l.quantity, ImageURL: abs(l.image), Price: l.final_line_price / 100, UnitPrice: l.final_price / 100, ProductURL: abs(l.url), VariantID: l.variant_id, Lot: pr.Lot || '' });
        else gifts.push(l.product_title);
      });
      if (!paid.length) return;
      /* Lot concerné par cet ajout (s'il y en a un) */
      var lotName = '', pack = '', pinces = 0, hint = window.pzLotHint || null;
      just.forEach(function (a) { if (!lotName && a.props && a.props.Lot) { lotName = a.props.Lot; pack = a.props._pz_pack || ''; } });
      if (lotName) {
        if (hint && hint.pack === pack && hint.pinces) pinces = hint.pinces;
        else (cart.items || []).forEach(function (l) { if (l.original_price > 0 && l.properties && l.properties._pz_pack === pack) pinces += l.quantity; });
      }
      var lots = [];
      paid.forEach(function (x) { if (x.Lot && lots.indexOf(x.Lot) < 0) lots.push(x.Lot); });
      /* Ajout hors lot (upsell, pince seule…) alors que le panier contient déjà un lot : on garde le nom du lot du panier. */
      if (!lotName && lots.length) paid.forEach(function (x) { if (x.Lot) pinces += x.Quantity; });
      var props = {
        LotName: lotName || lots.join(' + '), AddedLot: lotName, PinceCount: pinces, Lots: lots, IsLot: !!lots.length,
        Items: paid, ItemNames: paid.map(function (x) { return x.ProductName + (x.Variant ? ' – ' + x.Variant : '') + (x.Quantity > 1 ? ' ×' + x.Quantity : ''); }),
        ItemCount: paid.reduce(function (s, x) { return s + x.Quantity; }, 0), Gifts: gifts,
        ImageURL: paid[0].ImageURL, CartTotal: cart.total_price / 100, $value: cart.total_price / 100, Currency: cart.currency,
        CartItemCount: cart.item_count, CartURL: location.origin + root + 'cart', PageURL: location.href,
        AddedVariantIDs: just.map(function (a) { return a.id; }).filter(Boolean)
      };
      (window.klaviyo = window.klaviyo || []).push(['track', NAME, props]);
    }).catch(function () {});
  }
  if (typeof nf === 'function') {
    window.fetch = function (input, init) {
      var p = nf.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (isAdd(u)) { var b = init && init.body; p.then(function (r) { if (r && r.ok) schedule(b); }, function () {}); }
      } catch (e) {}
      return p;
    };
  }
  try {
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { try { this.__pzAdd = isAdd(u); } catch (e) {} return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (this.__pzAdd) { var x = this; x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) schedule(body); }); }
      } catch (e) {}
      return XS.apply(this, arguments);
    };
  } catch (e) {}
})();
